import { registriWS } from 'util/AppConfig.jsx';
import { checkStatus, parseJSON } from 'util/Ajax/responseUtils.jsx';
import authFetch from 'util/Ajax/customAjaxCalls.jsx';

// setting base urls for webservices
const wsRegistriURL = registriWS;

export function retrieveUser() {
  return (
    authFetch(`${wsRegistriURL}/userInfo`, {
      credentials: 'include',
    }, false)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => response.payLoad)
  );
}
